import { gql } from '@apollo/client';

export const adPerformanceReportQuery = gql`
  query GetAdPerformanceReport($input: AdPerformanceReportWidgetInput!) {
    analyticsAdPerformanceReport(input: $input) {
      hirerId
    }
  }
`;
